(() => {
function formatPrice(value, currencySymbol) {
  return `${currencySymbol}${Math.round(value)}`;
}

function updateDisplay(slider) {
  const facet = slider.closest('.plp-price-facet');
  if (!facet) return;
  const which = slider.dataset.plpPriceInput;
  const display = facet.querySelector(`[data-plp-price-display="${which}"]`);
  if (!display) return;
  const currencySymbol = display.textContent.trim().charAt(0) || '$';
  const max = parseInt(slider.getAttribute('max'), 10);
  const value = parseInt(slider.value, 10);
  const isAtMaxForMax = which === 'max' && value === max;
  display.textContent = `${formatPrice(value, currencySymbol)}${isAtMaxForMax ? '+' : ''}`;
}

function dispatchChange(target) {
  target.dispatchEvent(new Event('change', { bubbles: true }));
}

function syncName(input) {
  const param = input.dataset.priceParam;
  if (!param) return;
  const value = parseInt(input.value, 10);
  const bound = input.dataset.plpPriceInput === 'min'
    ? value > parseInt(input.min, 10)
    : value < parseInt(input.max, 10);
  if (bound) {
    input.setAttribute('name', param);
  } else {
    input.removeAttribute('name');
  }
}

function syncNames(root = document) {
  root.querySelectorAll('.plp-price-slider__input').forEach(syncName);
}

function clampSliders(slider) {
  const facet = slider.closest('.plp-price-facet');
  if (!facet) return;
  const minInput = facet.querySelector('[data-plp-price-input="min"]');
  const maxInput = facet.querySelector('[data-plp-price-input="max"]');
  if (!minInput || !maxInput) return;
  const minVal = parseInt(minInput.value, 10);
  const maxVal = parseInt(maxInput.value, 10);
  if (minVal > maxVal) {
    if (slider === minInput) {
      minInput.value = maxVal;
    } else {
      maxInput.value = minVal;
    }
    updateDisplay(minInput);
    updateDisplay(maxInput);
  }
}

function handleSliderInput(event) {
  const slider = event.target;
  if (!slider.matches('.plp-price-slider__input')) return;
  clampSliders(slider);
  updateDisplay(slider);
  const facet = slider.closest('.plp-price-facet');
  if (facet) syncNames(facet);
}

function handlePresetClick(event) {
  const label = event.target.closest('.plp-price-preset');
  if (!label) return;
  const input = label.querySelector('.plp-price-preset__input');
  if (!input) return;

  event.preventDefault();
  event.stopPropagation();

  const facet = input.closest('.plp-price-facet');
  if (!facet) return;
  const minInput = facet.querySelector('[data-plp-price-input="min"]');
  const maxInput = facet.querySelector('[data-plp-price-input="max"]');
  if (!minInput || !maxInput) return;

  const willCheck = !label.classList.contains('plp-price-preset--active');
  const maxAttr = maxInput.getAttribute('max');
  const newMin = willCheck ? (input.dataset.min || '0') : '0';
  const newMax = willCheck ? (input.dataset.max || maxAttr) : maxAttr;

  const params = new URLSearchParams(window.location.search);
  const currentMin = params.get('filter.v.price.gte') || '0';
  const currentMax = params.get('filter.v.price.lte') || maxAttr;
  if (currentMin === newMin && currentMax === newMax) return;

  facet.querySelectorAll('.plp-price-preset__input').forEach((other) => {
    other.checked = (other === input) ? willCheck : false;
    other.closest('.plp-price-preset')?.classList.toggle('plp-price-preset--active', other.checked);
  });

  minInput.value = newMin;
  maxInput.value = newMax;
  updateDisplay(minInput);
  updateDisplay(maxInput);
  syncName(minInput);
  syncName(maxInput);
  dispatchChange(maxInput);
}

function handleStrayPresetChange(event) {
  const input = event.target.closest?.('.plp-price-preset__input');
  if (!input) return;
  const facet = input.closest('.plp-price-facet');
  if (!facet) return;
  const maxInput = facet.querySelector('[data-plp-price-input="max"]');
  const maxAttr = maxInput?.getAttribute('max');
  const newMin = input.checked ? (input.dataset.min || '0') : '0';
  const newMax = input.checked ? (input.dataset.max || maxAttr) : maxAttr;
  const params = new URLSearchParams(window.location.search);
  const currentMin = params.get('filter.v.price.gte') || '0';
  const currentMax = params.get('filter.v.price.lte') || maxAttr;
  if (currentMin === newMin && currentMax === newMax) {
    event.stopPropagation();
  }
}

function handleClearClick(event) {
  const clear = event.target.closest?.('facet-clear-component, .facets__clear');
  if (!clear) return;
  const facet = clear.closest('.plp-price-facet');
  if (!facet) return;
  facet.querySelectorAll('.plp-price-slider__input').forEach((input) => {
    input.value = input.dataset.plpPriceInput === 'min' ? input.min : input.max;
    updateDisplay(input);
    input.removeAttribute('name');
  });
}

function syncDisplays(root = document) {
  root.querySelectorAll('.plp-price-slider__input').forEach(updateDisplay);
}

function bootstrap() {
  syncDisplays();
  syncNames();
}

document.addEventListener('input', handleSliderInput);
document.addEventListener('click', handleClearClick, true);
document.addEventListener('click', handlePresetClick, true);
document.addEventListener('change', handleStrayPresetChange);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap);
} else {
  bootstrap();
}

document.addEventListener('shopify:section:load', bootstrap);

const observer = new MutationObserver((mutations) => {
  for (const m of mutations) {
    for (const node of m.addedNodes) {
      if (!(node instanceof Element)) continue;
      if (node.matches?.('.plp-price-slider__input')) {
        updateDisplay(node);
        syncName(node);
      } else if (node.querySelector?.('.plp-price-slider__input')) {
        syncDisplays(node);
        syncNames(node);
      }
    }
  }
});
observer.observe(document.body, { childList: true, subtree: true });
})();
